import { GetSharedCandidatesRosterDataOutput } from '$store/modules/candidates';
import { useEffect, useRef, useState } from 'react';
import SPKPanelHiddenSkills from './SPKPanelHiddenSkills';
import SPKPanelDisplayedSkills from './SPKPanelDisplayedSkills';

const SPKPanelSkills = ({
  skills,
}: {
  skills: GetSharedCandidatesRosterDataOutput['candidates'][number]['CandidateSkills'];
}) => {
  const [visibleSkills, setVisibleSkills] = useState(
    [] as GetSharedCandidatesRosterDataOutput['candidates'][number]['CandidateSkills']
  );
  const [hiddenSkills, setHiddenSkills] = useState(
    [] as GetSharedCandidatesRosterDataOutput['candidates'][number]['CandidateSkills']
  );
  const [overflowStart, setOverflowStart] = useState<number>();
  const [showHiddenSkills, setShowHiddenSkills] = useState(false);

  const containerRef = useRef<HTMLDivElement | null>(null);
  const showHiddenSkillsButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (!skills || !showHiddenSkillsButtonRef) return;

    if (overflowStart === undefined) {
      setVisibleSkills(skills);
      return;
    }

    if (overflowStart === 0) {
      showHiddenSkillsButtonRef.current?.classList.add('!hidden');
      return;
    }

    const visible = skills.slice(0, overflowStart);
    const hidden = skills.slice(overflowStart);

    setVisibleSkills(visible);
    setHiddenSkills(hidden);

    if (hidden.length > 0) {
      setTimeout(() => {
        containerRef.current?.appendChild(
          showHiddenSkillsButtonRef.current as HTMLButtonElement
        );
      }, 200);
    } else {
      showHiddenSkillsButtonRef.current?.classList.add('!hidden');
    }
  }, [skills, overflowStart]);

  return (
    <div
      className={`transition-all duration-700 flex flex-row gap-2 flex-wrap overflow-hidden ${
        !showHiddenSkills ? 'max-h-10 md:max-h-10' : 'max-h-full'
      }`}
      ref={containerRef}
    >
      <button
        className={`text-xs border border-employer-primary text-employer-primary p-1 rounded-full border-solid ${
          !showHiddenSkills ? 'flex' : 'hidden'
        }`}
        ref={showHiddenSkillsButtonRef}
        onClick={() => setShowHiddenSkills(true)}
        type="button"
      >
        Show More
      </button>
      {visibleSkills.map((singleSkill, index) => {
        return (
          <SPKPanelDisplayedSkills
            skill={singleSkill.Skill.title}
            setOverflowIndex={setOverflowStart}
            index={index}
            containerRef={containerRef.current}
            key={`singleSkill_${singleSkill.Skill.title}`}
            totalSkills={skills.length}
          />
        );
      })}
      <SPKPanelHiddenSkills
        hiddenSkills={hiddenSkills}
        setShowHiddenSkills={setShowHiddenSkills}
        showHiddenSkills={showHiddenSkills}
      />
    </div>
  );
};

export default SPKPanelSkills;
